"use client";

import React from "react";
import { ArrowDownRight, Phone } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Estimate() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="zamów-wycenę" data-nav="dark" className="dark bg-background text-foreground relative isolate overflow-hidden py-24 sm:py-32">
      {/* Background Architectural Photography */}
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723616/img/finished_interior_microcement_floor.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723616/img/finished_interior_microcement_floor.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723616/img/finished_interior_microcement_floor.png-wvc-sizes" alt="Minimalistyczne wnętrze domu z posadzką mikrocementową wykonaną przez BUDSYS" loading="lazy" decoding="async" className="h-full w-full object-cover object-center" />
        {/* Architectural Contrast Scrim */}
        <div className="absolute inset-0 bg-gradient-to-b from-background/90 via-background/75 to-background/95" />
      </div>

      <div className="relative mx-auto max-w-5xl px-6 sm:px-12 lg:px-16">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45,
        ease: [0.16, 1, 0.3, 1]
      }} className="mx-auto max-w-3xl text-center">
          {/* Architectural Datum Accent Notch */}
          <div className="mx-auto mb-6 flex items-center justify-center gap-2">
            <span className="h-[2px] w-8 bg-accent" />
            <span className="text-xs uppercase tracking-widest text-muted-foreground font-mono">
              Kalkulacja inwestycji
            </span>
            <span className="h-[2px] w-8 bg-accent" />
          </div>

          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl lg:text-5xl">
            Zamów wycenę
          </h2>

          <p className="mt-5 text-base sm:text-lg text-muted-foreground leading-relaxed">
            Przygotowujemy indywidualną kalkulację na podstawie projektu architektonicznego, specyfikacji materiałowej oraz metrażu planowanych prac.
          </p>

          {/* Action Row */}
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild size="lg" className="w-full sm:w-auto h-12 px-8 bg-accent text-accent-foreground hover:bg-accent/90 rounded-md font-semibold text-base transition-[background-color,box-shadow] shadow-md hover:shadow-lg">
              <Link to="#kontakt" className="inline-flex items-center gap-2">
                <span>Zamów wycenę</span>
                <ArrowDownRight className="size-4 text-accent-foreground" />
              </Link>
            </Button>

            <a href="tel:796280315" className="inline-flex items-center justify-center gap-2.5 h-12 px-6 rounded-md border border-border bg-background/50 backdrop-blur-sm text-foreground hover:bg-muted text-sm font-medium transition-[background-color,border-color] w-full sm:w-auto">
              <Phone className="size-4 text-accent" />
              <span className="font-mono tracking-tight">+48 796 280 315</span>
            </a>
          </div>

          {/* Operational Scope Footnote */}
          <div className="mt-12 pt-8 border-t border-border/40 grid grid-cols-1 sm:grid-cols-2 gap-4 text-xs text-muted-foreground">
            <div className="flex items-center justify-center sm:justify-end gap-2">
              <span className="size-1.5 rounded-full bg-accent" />
              <span>Budowa domów i roboty ziemne: Bielsko-Biała i okolice (+25 km)</span>
            </div>
            <div className="flex items-center justify-center sm:justify-start gap-2">
              <span className="size-1.5 rounded-full bg-accent" />
              <span>Posadzki mikrocementowe i żywice: cała Polska</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}